import { createMiddleware } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";
import { supabaseAdmin } from "@/integrations/supabase/client.server";

// Separado do middleware para poder ser testado isoladamente, sem precisar
// simular o pipeline de execução do TanStack Start.
export async function isUserAdmin(userId: string): Promise<boolean> {
  const { data, error } = await supabaseAdmin
    .from("admin_users")
    .select("user_id")
    .eq("user_id", userId)
    .maybeSingle();
  if (error) throw error;
  return !!data;
}

// Encadeia requireSupabaseAuth (valida o JWT) com a checagem de role: só
// segue se o usuário autenticado estiver na tabela admin_users. Nunca expõe
// service_role ao client — a checagem acontece inteiramente no servidor.
export const requireAdmin = createMiddleware({ type: "function" })
  .middleware([requireSupabaseAuth])
  .server(async ({ next, context }) => {
    const allowed = await isUserAdmin(context.userId);
    if (!allowed) throw new Error("Forbidden: not an admin");

    return next();
  });
